import StringUtils from "src/utils/stringUtils";

export function generatePieChartData(items: Map<string, number> | undefined, totalCli: number) {
  if (totalCli === 0) {
    return [];
  } else {
    if (items) {
      // Convert the map entries to an array and iterate over them
      return Object.entries(items).map(([label, value]) => ({
        title: convertCamelCaseToTitleCase(label),
        percentage: calculatePercentage(value, totalCli),
        value: value,
      }));
    } else {
      return [];
    }
  }

}

function calculatePercentage(value: number | undefined, total: number): number {
  if (value !== undefined) {
    return (value / total) * 100;
  }
  return 0;
}

export function convertCamelCaseToTitleCase(input: string): string {
  switch (input) {
    case 'failed':
    case 'success':
    case 'ZeroVariance':
      return StringUtils.convertCamelCaseToTitleCase(input);
    case 'Apttus data Missing':
      return 'Apttus Data Missing';
    default:
      return input;
  }
}

const REASON_CODE_DESCRIPTIONS: Record<string, string> = {
  'REPORT_GENERATION_ERROR': 'The report failed to generate due to an unexpected error during processing.',
  'GL_SERVICE_FAILURE': 'The GL balance pull from the IC GL Service failed for this entity.',
  'SQS_PUBLISH_FAILURE': 'The report trigger message failed to publish to the processing queue.',
  'TP_CHARGE_DATA_NOT_FOUND': 'No TP charge data was found for this CLI in the current period.',
  'APTTUS_DATA_MISSING': 'The Apttus CLI configuration data is missing or incomplete.',
  'TIMEOUT': 'The report generation timed out before completing.',
};

export function getReasonCodeDescription(reasonCode: string): string {
  return REASON_CODE_DESCRIPTIONS[reasonCode] || reasonCode;
}